var React = require('react');
var ButtonLink = require('react-router-bootstrap').ButtonLink;
var Col = require('react-bootstrap').Col;
var Link = require('react-router').Link;
var Row = require('react-bootstrap').Row;
var Table = require('react-bootstrap').Table;
var moment = require('moment');

var ServiceActions = require('../../actions/ServiceActions');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ClientStore = require('../../stores/ClientStore');
var ContactStore = require('../../stores/ContactStore');
var UserStore = require('../../stores/UserStore');
var Loading = require('../Loading');

import PageHeader from '../Layout/PageHeader';

function getState() {
  const client = ClientStore.get()
  const roles = UserStore.getCurrentRoles()
  const owner = roles.indexOf('OWNER') > -1
  const admin = roles.indexOf('ADMIN') > -1

  return {
    client,
    partners: client ? client.authorisedPartners : [] || [],
    contacts: ContactStore.get(),
    loading: ContactStore.loading() || ClientStore.loading(),
    user: UserStore.getUser(),
    deny: !owner && !admin,
    readOnly: !owner,
  }
}

var Access = React.createClass({
  componentDidMount: function() {
    ClientStore.addChangeListener(this.update);
    ContactStore.addChangeListener(this.update);
    UserStore.addChangeListener(this.update);
  },
  componentWillMount: function () {
    this.setState(getState())

    var user = UserStore.getUser();

    if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
      ServiceActions.getServices(user);
    }
  },
  componentWillUnmount: function () {
    ClientStore.removeChangeListener(this.update);
    ContactStore.removeChangeListener(this.update);
    UserStore.removeChangeListener(this.update);
  },
  update: function () {
    this.setState(getState())
  },
  render: function () {
    if (this.state.deny) {
      return (
        <section>
          <PageHeader><h1>Authorised Users and Representatives</h1></PageHeader>

          <section className="powerwidget red">
            <header><h2><i className="fa fa-users"></i> Access Denied</h2></header>
            <div className="inner-spacer">
              <p>
                You do not have access to manage user access.
              </p>
            </div>
          </section>
        </section>
      )
    }

    return (
      <section>
        <PageHeader><h1>Authorised Users and Representatives</h1></PageHeader>

        <Row>
          <Col md={7} lg={7}>
            {(this.state.client && this.state.client.relationshipInvites.length > 0) && (
              <section className="powerwidget pink">
                <header><h2><i className="fa fa-users"></i> Pending Authorisations</h2></header>
                <div className="inner-spacer">
                  <p>
                    These individuals have not yet completed their authorisation and are not considered
                    authorised on this account until they complete the steps required that were emailed
                    to them.
                  </p>
                </div>
                <div className="inner-spacer-zero-padding">
                  <div className="table-responsive">
                    <Table className="table-striped table-hover">
                      <thead>
                      <tr>
                        <th>Name | Email</th>
                        <th>Access</th>
                        <th>Expires</th>
                        <th style={{ width: '1%', textAlign: 'right' }}>Manage</th>
                      </tr>
                      </thead>
                      <tbody>
                      {this.state.loading && (
                        <tr><td colSpan={3}><Loading /></td></tr>
                      )}
                      {this.state.client.relationshipInvites.map(invite => (
                        <tr key={invite.id}>
                          <td>
                            {invite.first_name} {invite.last_name}<br />
                            <small className="text-muted">{invite.email}</small>
                          </td>
                          <td>
                            {invite.roles.join(', ')}
                          </td>
                          <td>
                            {moment.duration(moment(invite.expires).diff()).humanize()}
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <ButtonLink disabled={this.state.readOnly} bsSize="sm" to="access-manage-invite" params={{ id: invite.id }}>
                              <i className="fa fa-mail-forward"></i> Manage
                            </ButtonLink>
                          </td>
                        </tr>
                      ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </section>
            )}

            <section className="powerwidget purple">
              <header><h2><i className="fa fa-users"></i> Authorised Users</h2></header>
              <div className="inner-spacer">
                <p>
                  Authorised users are able to contact us on behalf of{' '}
                  <strong>{this.state.client ? this.state.client.name : <Loading />}</strong>{' '}
                  and perform actions that they are authorised to perform.
                </p>

                <p>
                  The following roles can be assigned to individuals:
                </p>

                <ul>
                  <li><strong>Technical View</strong>: Allows the individual to view but not make any changes to services on this account.</li>
                  <li><strong>Technical Manage</strong>: Allows the individual to manage technical aspects of services on this account.</li>
                  <li><strong>Accounting</strong>: Allows the individual to view and manage all financial related information on this account.</li>
                  <li><strong>Admin</strong>: Full access to the account except for management of users.</li>
                  <li><strong>Owner</strong>: Full access to the account.</li>
                  {this.props.showPartner && (
                    <li><strong>Partner</strong>: This user has access to the partner portal and related functions.</li>
                  )}
                </ul>
              </div>
              <div className="inner-spacer-zero-padding">
                <div className="table-responsive">
                  <Table className="table-striped table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: '60%' }}>Name | Email</th>
                        <th style={{ width: '30%' }}>Access</th>
                        <th style={{ textAlign: 'right' }}>Manage</th>
                      </tr>
                    </thead>
                    <tfoot>
                      <tr>
                        <td colSpan={3} style={{ textAlign: 'right' }}>
                          <ButtonLink disabled={this.state.readOnly} bsSize="sm" to="access-new">
                            <i className="fa fa-user-plus"></i> Authorise New Individual
                          </ButtonLink>
                        </td>
                      </tr>
                    </tfoot>
                    <tbody>
                      {this.state.loading && (
                        <tr><td colSpan={3}><Loading /></td></tr>
                      )}
                      {this.state.contacts.map(rel => (
                        <tr key={rel.user.id}>
                          <td>
                            {rel.user.first_name} {rel.user.last_name}<br />
                            <small className="text-muted">{rel.user.email}</small>
                          </td>
                          <td>
                            {rel.roles.join(', ')}
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            {(this.state.user && rel.user.id !== this.state.user.id) && (
                              <ButtonLink disabled={this.state.readOnly} bsSize="sm" to="access-manage" params={{ id: rel.user.id }}>
                                <i className="fa fa-edit"></i> Manage
                              </ButtonLink>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </section>
          </Col>

          <Col md={5} lg={5}>
            <section className="powerwidget green-acid">
              <header><h2><i className="fa fa-briefcase"></i> Authorised Partners</h2></header>
              <div className="inner-spacer">
                <p>
                  Authorised partners are able to contact us on behalf of{' '}
                  <strong>{this.state.client ? this.state.client.name : <Loading />}</strong> and
                  perform technical management of your account.
                </p>

                <p>
                  Authorised partners will provide you with a link to visit that
                  will allow you to authorise them.
                </p>
              </div>
              <div className="inner-spacer-zero-padding">
                <div className="table-responsive">
                  <Table className="table-striped table-hover">
                    <thead><tr>
                      <th style={{ width: '100%' }}>Partner</th>
                      <th style={{ textAlign: 'right' }}>Manage</th>
                    </tr></thead>
                    <tbody>
                      {this.state.loading && (
                        <tr><td colSpan={2}><Loading /></td></tr>
                      )}
                      {(this.state.client && this.state.client.authorisedPartners.length === 0) && (
                        <tr><td colSpan={2}>
                          You do not currently have any authorised partners linked to {this.state.client.name}.
                        </td></tr>
                      )}
                      {(this.state.client && this.state.client.authorisedPartners.length > 0) && this.state.client.authorisedPartners.map(partner => (
                        <tr key={partner.id}>
                          <td>
                            <strong>{partner.partner.name}</strong><br />
                            <small className="text-muted">{partner.partner.number}</small><br />
                            <small className="text-muted"><a target="_blank" rel="noreferrer" href={partner.partner.url}>{partner.partner.url}</a></small>
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <ButtonLink disabled={this.state.readOnly} bsSize="sm" to="access-manage-partner" params={{ id: partner.partner.authHash }}>
                              <i className="fa fa-edit"></i> Manage
                            </ButtonLink>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </section>
            <section className="powerwidget green">
              <header><h2><i className="fa fa-briefcase"></i> Technical Partners</h2></header>
              <div className="inner-spacer">
                <p>
                  Do you have a technical partner organisation that manages your internet or IT
                  infrastructure?
                </p>

                <p>
                  They can apply to become a Partner with Infinite Networks that will allow them to
                  manage any technical aspects of their client&apos;s accounts with us.
                </p>

                <p>
                  Get them to call us on 1300 790 337 to get started.
                </p>
              </div>
            </section>
          </Col>
        </Row>
      </section>
    );
  }
})
module.exports = Access;



// WEBPACK FOOTER //
// ./app/components/Access/Access.js